import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import eventsService from "../../../Axios/services/events.service";
import { useParams, useNavigate } from "react-router-dom";
import "./EventPageTasks.scss";
import {
  setCurrentPage,
  setSidebarRouteData,
} from "../../../store/actions/mainActions";
import { useTranslation } from "react-i18next";
import { EventTask } from "./components/EventTask";
import {
  setTasks,
  setTotalEventTasks,
  setTotalEventTasksLoading,
  setUserCompletedEventTasks,
} from "../../../store/actions/contentActions";
import { ISeminarTask } from "../../../models/tasks";
import { useLocation } from "react-router-dom";
import MainTasksHeader from "./components/MainTasksHeader";

import styles from "./EventPageTasks.module.scss";
import { userOwnsEvent } from "../EventPage/utils/utils";
import { mapSelectionsToClassIds } from "../../../utils/classIdMapper";

export const EventPageTasks = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { currentEvent } = useSelector((state: any) => state.main);
  const { eventTasks, totalEventTasks, userCompletedEventTasks, isTotalEventTasksLoading } = useSelector(
    (state: any) => state.content
  );
  const { me } = useSelector((state: any) => state.auth);
  const { fromMyCampus = false } = location.state || {};
  
  const [event, setEvent] = useState(null);
  const [entityLanguage, setEntityLanguage] = useState("common");
  const [t] = useTranslation(entityLanguage);
  const isNotEnglish = entityLanguage !== "English";

  useEffect(() => {
    if (event !== null && event._id && me) {
      const isUserRegistered = userOwnsEvent(event, me);
      if (!isUserRegistered) {
        navigate(`/my-campus/event/timeline/${event._id}`);
      }
    }
  }, [event, me, navigate]);

  useEffect(() => {
    if ((!currentEvent || currentEvent._id !== id) && fromMyCampus) {
      dispatch(setTotalEventTasksLoading(true));
    }
    if (me && currentEvent && currentEvent._id === id) {
      initializeEvent();
    } else if (me) {
      fetchEvent();
    }
    return () => {
      dispatch(setSidebarRouteData({}));
      dispatch(setCurrentPage(""));
      dispatch(setTasks([]));
    };
  }, [me, currentEvent, id]);

  const fetchEvent = async () => {
    console.log("fetchEvent");
    try {
      loadEventData();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const loadEventData = async () => {
    const hasCurrentEvent = Boolean(currentEvent && currentEvent._id === id);
    const eventData = hasCurrentEvent ? currentEvent : (await eventsService.getEvent(id));
    if (eventData) {
      me.classes = me.classes?.filter((cls) => cls !== null);
      setEntityLanguage(eventData.language);
      loadEventSideBar(eventData);

      loadEventTasks();
    }
  };
  const loadEventSideBar = (event: any) => {
    setEvent(event);
    setEntityLanguage(event.language);
    localStorage.setItem("entityLanguage", event.language);
    dispatch(setCurrentPage("EventPage"));
    dispatch(setSidebarRouteData({ id }));
  };

  const loadEventTasks = async () => {
    const tasks: ISeminarTask[] = await getSeminarTasks(id, me._id);
    dispatch(setTotalEventTasks(tasks.length));
    dispatch(setTotalEventTasksLoading(false));
    dispatch(setUserCompletedEventTasks(countCompletedTasks(tasks)));
    dispatch(setTasks(tasks));
  };

  const getSeminarTasks = async (eventId, userId) => {
    return await eventsService.getSeminarTasksById(eventId, userId);
  };

  const countCompletedTasks = (tasks) => {
    return tasks.filter((task) => {
      if (task.Type__c === "Class Ranking") {
        return (
          task.Participant_Choices__r?.records?.[0]?.Selected_Option__c &&
          task.Participant_Choices__r?.records?.[0]?.Second_Option__c
        );
      }
  
      return (
        (task.Allow_Select_All__c &&
          task.Participant_Choices__r &&
          task.Participant_Choices__r?.records?.length >= task.Min_Selection__c) ||
        (!task.Allow_Select_All__c && task.Participant_Choices__r)
      );
    }).length;
  };
  

  const initializeEvent = async () => {
    loadEventSideBar(currentEvent);
    if (!eventTasks || eventTasks.length === 0) {
      await loadEventTasks();
    }
  };

  if (isTotalEventTasksLoading || !event || !eventTasks || eventTasks.length === 0) {
    return (
      <div className="loaderContainer d-flex flex-column">
        <div className="loader"></div>
        <div className="loaderText">Loading Event Tasks</div>
      </div>
    );
  }

  const allUserSelections = mapSelectionsToClassIds(eventTasks);

  return (
    <div className={`event-page container-fluid ${isNotEnglish ? "alignRight" : ""}`}>
      <MainTasksHeader
        event={event}
        isNotEnglish={isNotEnglish}
      />
      <div className={styles.tasksContainer}>
        <div className={styles.title} dangerouslySetInnerHTML={{
          __html: t('tasksCompleted', {
            count: userCompletedEventTasks,
            total: totalEventTasks
          })
        }}>
        </div>
        {eventTasks.map((task: ISeminarTask) => (
          <EventTask
            key={task.Id}
            task={task}
            eventId={event._id}
            language={event.language}
            allUserSelections={allUserSelections}
          />
        ))}
      </div>
    </div>
  );
};
